const RECEIVE_SHARDS_SERVICE_DATA = 'src/omniShareOfShelfShardsService/RECEIVE_SHARDS_SERVICE_DATA' as const;
const START_FETCH = 'src/omniShareOfShelfShardsService/START_FETCH' as const;
const END_FETCH = 'src/omniShareOfShelfShardsService/END_FETCH' as const;

export default { RECEIVE_SHARDS_SERVICE_DATA, START_FETCH, END_FETCH };
